import { useEffect } from 'react';
import { createSearchParams, useLocation, useSearchParams } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/publication.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import TabList from '@/components/common/Tab/TabList/TabList';
import PublicationAdvertisementGuide from '@/components/Publication/PublicationAdvertisementGuide/PublicationAdvertisementGuide';
import PublicationArticlePayment from '@/components/Publication/PublicationArticlePayment/PublicationArticlePayment';
import PublicationConfirm from '@/components/Publication/PublicationConfirm/PublicationConfirm';
import PublicationJournalGuide from '@/components/Publication/PublicationJournalGuide/PublicationJournalGuide';
import PublicationJournalSearch from '@/components/Publication/PublicationJournalSearch/PublicationJournalSearch';
import PublicationSubmissionGuide from '@/components/Publication/PublicationSubmissionGuide/PublicationSubmissionGuide';

const menuList = ['저널안내', '저널검색', '투고안내', '광고안내', '게재료 결제'];

const Publication = () => {
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();

	const params = searchParams.get('menu') ?? (location.state as { menu?: string } | null)?.menu ?? '저널안내';
	const stepParams = searchParams.get('step') ?? (location.state as { step?: string } | null)?.step ?? undefined;

	// 예전처럼 state만 넘어온 경우 한 번 URL에 반영(새로고침 후에도 동일 화면 유지)
	useEffect(() => {
		const state = location.state as { menu?: string; step?: string } | null;
		if (!state?.menu || searchParams.get('menu')) {
			return;
		}
		const next = createSearchParams();
		next.set('menu', state.menu);
		if (state.step) {
			next.set('step', state.step);
		}
		setSearchParams(next, { replace: true });
	}, [location.state, searchParams, setSearchParams]);

	const handleSetMenu = (menu: string) => {
		setSearchParams((prev) => {
			const next = new URLSearchParams(prev);
			next.set('menu', menu);
			if (menu !== menuList[4]) {
				next.delete('step');
			}
			return next;
		});
	};

	return (
		<main>
			<SubBanner subTitle="Publication" title="간행물" img={mainBanner} />
			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === menuList[0] && <PublicationJournalGuide />}
			{params === menuList[1] && <PublicationJournalSearch />}
			{params === menuList[2] && <PublicationSubmissionGuide />}
			{params === menuList[3] && <PublicationAdvertisementGuide />}
			{params === menuList[4] && stepParams !== '등록 확인' && <PublicationArticlePayment />}
			{params === menuList[4] && stepParams === '등록 확인' && <PublicationConfirm />}
		</main>
	);
};

export default Publication;
